<template>
  <!-- 车辆黑名单 -->
  <div class="page-container">
    <div v-if="!isAdjust">
      <div class="page_title">
        <div class="page_title_desc">车辆黑名单</div>
        <kt-button
            icon=""
            label="操作历史"
            perms="-1"
            type="text"
            size="medium"
            class="whiteList_box_title_cz"
            @click="getAdjust"/>
      </div>
      <el-divider></el-divider>
      <!--工具栏-->
      <div class="toolbar">
        <el-form :inline="true" :model="filterForm" :size="size">
          <el-form-item label="">
            <el-input
              v-model="filterForm.carLicensePlateNo"
              placeholder="请输入车牌号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="filterForm.createTime"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="filterForm.createUser"
              placeholder="请输入操作人"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <kt-button
              icon="fa fa-search"
              label="搜索"
              perms="-1"
              type="primary"
              @click="handleSearch"
            />
          </el-form-item>
          <el-form-item>
            <kt-button
              icon="fa fa-share"
              label="重置"
              perms="-1"
              @click="handleReset"
              type="primary"
            />
          </el-form-item>
          <el-form-item>
            <kt-button
              label="添加"
              perms="30820"
              @click="handleAddBlackList"
              type="primary"/>
          </el-form-item>
          <el-form-item>
            <kt-button
              label="移除"
              perms="30821"
              @click="handleMoveBlackList"
              type="primary"/>
          </el-form-item>
        </el-form>
      </div>
      <!--表格树内容栏-->
      <el-table
        :data="carBlackList"
        stripe
        size="mini"
        style="width: 100%"
        row-key="id"
      >
        <el-table-column
          type="index"
          width="50"
          align="center"
          fixed
          label="序号"
        >
        </el-table-column>
        <el-table-column
          prop="carLicensePlateNo"
          align="center"
          label="车牌号"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          align="center"
          label="操作时间"
        >
        </el-table-column>
        <el-table-column
          prop="createUser"
          align="center"
          label="操作人"
        >
        </el-table-column>
      </el-table>
      <!--分页栏-->
      <div class="toolbar" style="padding: 20px">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="refreshPageRequest"
          :current-page="pageNo"
          :page-size="pageSize"
          :total="totalSize"
          style="float: right"
        >
        </el-pagination>
      </div>
    </div>
    
    <!--调整历史-->
    <AdjustHistory v-if="isAdjust" @Adjust="AdjustFun"/>
    <!-- 弹窗 -->
    <!--新增 移除弹窗-->
    <el-dialog
      :title="dialogTitle"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="550px"
      center>
        <el-form
          class="blackForm"
          :model="blackForm" 
          :rules="blackRules" 
          ref="blackForm" 
          label-width="70px"
          :size="size"
          label-position="left">
            <el-form-item label="车牌号" prop="carLicensePlateNo">
              <el-input v-model="blackForm.carLicensePlateNo" placeholder="请输入车牌号"></el-input>
            </el-form-item>
            <el-form-item label="原因" prop="remark">
              <el-input
                type="textarea"
                v-model="blackForm.remark"
                maxlength="100"
                show-word-limit
                :rows="4"
                placeholder="请输入原因"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button :size="size" @click="handleClose">取消</el-button>
          <el-button :size="size" type="primary" @click="submitblackForm">保存</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";
import AdjustHistory from './AdjustHistory';

export default {
  components: {
    KtButton,
    AdjustHistory
  },
  data() {
    return {
      size: "small",
      isAdjust: false,
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      filterTime: [],
      carBlackList: [],
      parkList: [],
      carNoList: [],
      addUserList: [],
      typeList: [],
      filterForm: {},
      dialogVisible: false,
      dialogTitle: '',
      blackForm: {},
      blackRules: {
        carLicensePlateNo: [{ required: true, message: "请输入车牌号", trigger: "blur" }],
        remark: [{ required: true, message: "请输入原因", trigger: "blur" }]
      },
      isAdd: true
    };
  },
  mounted() {
    this.getCarBlackList();
  },
  methods: {
    // 获取车辆黑名单列表
    async getCarBlackList() {
      let params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          businessType: 'carBlackList'
      }
      let index = 0
      for (let key in this.filterForm) {
        const val = this.filterForm[key]
        if (val && val !== '') {
          params['searchFieldList[' + index + '].fieldName'] = key
          if (key === 'createTime') {
            params['searchFieldList[' + index + '].rangeMinValue'] = val[0]
            params['searchFieldList[' + index + '].rangeMaxValue'] = val[1]
          } else {
            params['searchFieldList[' + index + '].singleValue'] = val
          }
          index++
        }
      }
      let res = await this.$api.blacklist.mGetCarBlackList(params);
      this.totalSize = res.data.totalSize;
      if (res.data && res.data.dtoList && res.data.dtoList.length > 0) {
        this.carBlackList = res.data.dtoList;
      } else {
        this.carBlackList = [];
      }
    },

    // 点击调整历史
    getAdjust() {
      this.isAdjust = true
    },

    // 接受调整历史子组件传回的值
    AdjustFun(val) {
      this.isAdjust = val
    },

    // 换页刷新和搜索
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getCarBlackList();
    },

    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getCarBlackList();
    },

    // 重置
    handleReset() {
      this.pageNo = 1;
      this.filterForm = {};
      this.handleSearch()
    },

    // 添加黑名单
    handleAddBlackList(){
      this.isAdd = true
      this.dialogVisible = true
      this.dialogTitle = '拉黑车辆'
    },

    // 移除白名单
    handleMoveBlackList(){
      this.isAdd = false
      this.dialogVisible = true
      this.dialogTitle = '移除黑名单'
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.$refs['blackForm'].resetFields()
    },

    // 添加黑名单
    async submitblackForm(){
      this.$refs['blackForm'].validate(async (valid) => {
        if (valid) {
          let confirmText = '',
            confirmTitle = '',
            requestApi = null;
          let params = {
            carLicensePlateNo: this.blackForm.carLicensePlateNo,
            remark: this.blackForm.remark
          }
          if(this.isAdd){
            confirmText = '是否确认拉黑该车辆，拉黑后该车辆不可继续报名煤矿运输'
            confirmTitle = '添加黑名单'
            requestApi = this.$api.blacklist.mAddCarBlackList
          } else {
            confirmText = '是否确认将该车辆移除黑名单，移除后该车辆可继续报名煤矿运输'
            confirmTitle = '移除黑名单'
            requestApi = this.$api.blacklist.mRemoveCarBlackList
            params.businessType = 'carBlackList'
          }
          let confirm = await this.$confirm(confirmText, confirmTitle);

          if(!confirm) return
          

          await requestApi(params)

          this.dialogVisible = false
          this.$refs['blackForm'].resetFields()
          this.$message({ message: "操作成功", type: "success" });
          this.getCarBlackList()
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.toolbar {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 30px;
}
.dialogDesc{
  text-align: center;
  font-weight: 600;
}
</style>